import { ChevronDown } from "lucide-react";
import { EQUIPMENT_FLAT_LIST } from "@/lib/equipmentTypes";

interface MobileSearchSummaryProps {
  origin?: string;
  destination?: string;
  equipmentTypes?: string[];
  loadType?: string;
  onEdit: () => void;
}

function getEquipShortLabel(enumVal: string): string {
  const found = EQUIPMENT_FLAT_LIST.find((t) => t.enumValue === enumVal);
  return found ? found.name : enumVal;
}

export function MobileSearchSummary({
  origin,
  destination,
  equipmentTypes,
  loadType,
  onEdit,
}: MobileSearchSummaryProps) {
  const o = origin?.trim() || "Anywhere";
  const d = destination?.trim() || "Anywhere";

  const extraParts: string[] = [];
  if (equipmentTypes && equipmentTypes.length > 0) {
    const first = getEquipShortLabel(equipmentTypes[0]);
    extraParts.push(
      equipmentTypes.length > 1 ? `${first} +${equipmentTypes.length - 1}` : first
    );
  }
  if (loadType && loadType !== "full" && loadType !== "both") {
    extraParts.push(loadType.charAt(0).toUpperCase() + loadType.slice(1));
  }
  const extra = extraParts.join(" · ");

  return (
    <div className="md:hidden p-2">
      <button
        type="button"
        onClick={onEdit}
        className="w-full flex items-center justify-between gap-2 px-3 py-2 rounded-lg border border-border bg-card text-left active:bg-muted transition-colors"
      >
        <div className="min-w-0 flex-1">
          <div className="text-[10px] uppercase tracking-wide text-muted-foreground font-bold">
            Search
          </div>
          <div className="text-sm font-medium truncate">
            {o} <span className="text-muted-foreground">→</span> {d}
          </div>
          {extra && (
            <div className="text-[11px] text-muted-foreground truncate">{extra}</div>
          )}
        </div>
        <span className="text-xs font-semibold text-brand-teal shrink-0">Edit</span>
        <ChevronDown className="h-4 w-4 text-muted-foreground shrink-0" />
      </button>
    </div>
  );
}
